<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fa fa-clipboard"></i>
        Q & A
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">Board</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">QNA</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              [{{model.type ? model.type.toUpperCase() : '-'}}]&nbsp;{{model.title}}
            </div>
            <div class="mb7">
              <span class="float-right">{{model.created_at | sdate}}</span>
            </div>
          </div>
          <hr>
          <b-card>
            <h4>Group info</h4>
            <hr>
            <b-row class="mb-2" v-if="model.group">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="opt_group_name">
                  Group
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_group_name" v-model="model.group.groupname"></b-form-input>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="opt_group_name">
                  Service
                </label>
              </b-col>
              <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
                <b-badge :disabled="lock" @keydown.enter="refresh" :variant="model.group.service === 'Basic' ? 'info' : 'success'" id="opt_group_name"> {{model.group.service}} </b-badge>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col md="12" class="text-center">
                <p>not found matched group</p>
              </b-col>
            </b-row>
            <br>          
            <h4 class="mt-3">From</h4>
            <hr>
            <b-row class="mb-2" v-if="model.user">
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="opt_username">
                  Username
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_username" v-model="model.user.username"></b-form-input>
              </b-col>
              <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                <label class="col-form-label" for="opt_user_permission">
                  Permission
                </label>
              </b-col>
              <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
                <b-form-input plaintext :disabled="lock" @keydown.enter="refresh" type="text" id="opt_user_permission" v-model="model.user.permissions"></b-form-input>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col md="12" class="text-center">
                <p>
                  not found matched user
                </p>
              </b-col>
            </b-row>
          </b-card>
          <!-- <hr>
          <h4>
            Q&A info
          </h4>
          <b-row class="mb-2">
            <b-col md="12">
              <v-select :disabled="true" label="text" v-model="model.type" :options="codes.BOARD_TYPE"></v-select>
            </b-col>
          </b-row> -->
          <b-card>
            <b-row class="d-flex flex-wrap align-items-center">
              <b-col class="title_sub">
                <span class="pull-right font_13">{{model.created_at | datetime}}</span>
                <h4 for="ph_question">Question</h4>
                <!-- <vue-editor v-model="model.question" :disabled="true" id="ph_question"></vue-editor> -->
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col class="col-xl-12 col-md-12">
                <vue-editor v-model="model.question" :disabled="true" id="ph_question"></vue-editor>
              </b-col>
            </b-row>
            <br>
            <b-row class="d-flex flex-wrap align-items-center mt-3">
              <b-col class="title_sub">
                <span class="pull-right font_13">{{model.answered_at | datetime}}</span>
                <h4 for="ph_answer">Answer</h4>
                <!-- <vue-editor v-model="model.answer" :disabled="lock" id="ph_answer"></vue-editor> -->
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col class="col-xl-12 col-md-12">
                <vue-editor v-model="model.answer" :disabled="lock" id="ph_answer"></vue-editor>
              </b-col>
            </b-row>
          </b-card>
          <b-button size="sm" v-if="!lock" class="btn btn-add" @click="save"> Save </b-button>
          <b-button size="sm" v-else variant="warning" :disabled="model.is_del" @click="edit"> Edit </b-button>
          <b-button size="sm" v-if="!lock && !add" variant="default" @click="cancel"> Cancel </b-button>
          <b-button size="sm" v-if="lock && model.id" variant="danger" :disabled="model.is_del" @click="confirm = true"> Remove </b-button>
          <b-button size="sm" class="float-right text-white" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove(model)" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <!-- {{model}} -->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>